import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CkLayout from "./components/checklist/CkLayout";
import './App.css';
import Layout from "./components/manage4me/Layout";
import HomePage from './components/checklist/HomePage';
import PrivacyPolicy from './components/privacyPolicy/PrivacyPolicy';
import TermsAndServices from './components/termsAndServices/TermsAndServices';
import Home from "./pages/Home";

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/checklist" element={<HomePage />} />
                    <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
                    <Route path="/termsAndServices" element={<TermsAndServices />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}
// function App() {
//     return (
//         <div className="App">
//             <BrowserRouter>
//                 <Routes>
//                     <Route path="/" element={<HomePage />} />
//                 </Routes>
//             </BrowserRouter>
//         </div>
//     );
// }

export default App;